@import '../../../theme.scss';

verdocs-template-settings {
  display: block;
  max-width: 600px;
  font-family: $verdocs-primary-font;

  > form {
    display: flex;
    flex-direction: column;
    background-color: $verdocs-grey-4;

    // The extra right padding helps ensure when dragged elements move to absolute positioning
    padding: 12px;

    h5 {
      font-size: 16px;
      font-weight: bold;
      color: $verdocs-grey-blue;
      margin: 0 0 10px 0;
    }

    label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      margin: 0 0 4px 0;
      color: $verdocs-bg-4;
    }

    input {
      border: none;
      font-size: 18px;
      padding: 3px 6px 3px 0;
      background: transparent;
      border-bottom: 1px solid $verdocs-dark-blue;

      &:focus {
        outline: none;
      }
    }

    .row {
      margin: 20px 0 0 0;
    }
  }

  .buttons {
    display: flex;
    column-gap: 8px;
    margin-top: 16px;
    flex-direction: row;
  }

  ::placeholder {
    color: $verdocs-bg-2;
  }
}
